import React from 'react'
import { Link } from "react-router-dom";
import HomeBlog from '../home/HomeBlog';


const Blog = () => {
    return (
        <>
            <div className="page-header dark-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Page Header Box Start */}
                            <div className="page-header-box">
                                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="A Complete Guide to Solar Energy ..." style={{ perspective: 400 }}>
                                    <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                                            A Complete Guide to Solar Energy ...
                                        </div>
                                    </div>
                                </h1>
                                <div className="post-single-meta wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <ol className="breadcrumb">
                                        <a href='/'> <li><i className="fa-regular fa-user" /> Home</li></a>
                                        <li><i className="fa-regular fa-clock" /> Our Blog</li>
                                    </ol>
                                </div>
                            </div>
                            {/* Page Header Box End */}
                        </div>
                    </div>
                </div>
            </div>
            <HomeBlog />
        </>
    )
}

export default Blog